import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Qualifications.css';

const PORTRAIT = '/kevinheadshot.png';
const SCHOOL_IMG = '/homepage.jpg';

const TIMELINE = [
  {
    period: 'Education',
    title: "Bachelor's in Marketing & Master's in Business",
    desc: "Bachelor's of Marketing from Rochester Institute of Technology, paired with a Master's in Business — combining marketing strategy with business acumen.",
  },
  {
    period: '13 Years',
    title: 'Chemung County Youth Bureau',
    desc: 'Optimizing state funding opportunities. Nearly 15 years of dedicated public service transitioning from the private sector.',
  },
  {
    period: '2020',
    title: 'Pandemic Response',
    desc: 'Worked at Chemung County Health Department creating software for the Mass Vaccination Center — stepping up when it mattered most.',
  },
  {
    period: '2021',
    title: 'Elected to School Board',
    desc: 'Horseheads Central School District Board of Education. Bringing accountability and vision to education leadership.',
  },
  {
    period: 'Now',
    title: 'Mayor of Horseheads',
    desc: '100% dedicated to the mission of building our community so future generations will want to raise their families here.',
  },
];

function Qualifications() {
  const pageRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = pageRef.current?.querySelectorAll('.animate');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="qual-page" ref={pageRef}>
      {/* HERO */}
      <section className="qual-hero">
        <div className="qual-hero__inner">
          <div className="qual-hero__img animate">
            <img src={PORTRAIT} alt="Kevin Adams" />
          </div>
          <div className="qual-hero__text">
            <span className="label animate">About Kevin</span>
            <h1 className="animate">Born & raised<br />in Horseheads</h1>
            <p className="qual-hero__lead animate">
              Three generations of the Adams family have called Horseheads home —
              drawn by safety, a sense of community, and access to an excellent
              school system. Kevin lives in the Village with his daughter, Lily,
              and his wife, Whitney.
            </p>
            <blockquote className="animate">
              "I am 100% dedicated to the mission of building our community so
              that future generations will want to raise their families here."
            </blockquote>
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="timeline-section">
        <div className="timeline-section__inner">
          <div className="timeline-header">
            <span className="label animate">Experience</span>
            <h2 className="animate">15 years of public service</h2>
          </div>

          <div className="timeline">
            {TIMELINE.map((item, i) => (
              <div className="timeline__item animate" key={i}>
                <div className="timeline__marker">
                  <div className="timeline__dot" />
                  {i < TIMELINE.length - 1 && <div className="timeline__line" />}
                </div>
                <div className="timeline__content">
                  <span className="timeline__period">{item.period}</span>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="values-section">
        <div className="values__inner">
          <div className="values__text">
            <span className="label animate">What Drives Kevin</span>
            <h2 className="animate">Community. Family. Future.</h2>
            <p className="animate">
              Kevin didn't just move to Horseheads — his family has been here for
              three generations. He understands our village because he's lived it.
              From the school board to the Youth Bureau, every role has been about
              one thing: making this community stronger for the people who call it home.
            </p>
            <Link to="/contact" className="btn btn--primary animate">Talk to Kevin</Link>
          </div>
          <div className="values__img animate">
            <img src={SCHOOL_IMG} alt="Kevin Adams community involvement" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Qualifications;
